import * as Swal from 'sweetalert2';
import { batch } from 'react-redux';
import {
  createOrderApi,
  makeBidApi,
  getOrdersApi,
  cancelOrderApi,
  confirmOrderApi,
  sendCompletedCodeApi,
  completeOrderApi,
  sendReviewApi,
  getOrdersInfoApi,
  getOneOrderApi,
} from '../../api/apiUrls/order';
import orderActionTypes from '../actionTypes/order.actionTypes';
import helpers from '../../helpers/helpers';
import messageActions from './messageActions';
import getPhotosWithUrls from '../../helpers/getPhotosWithUrls';
import { readMessageApi } from '../../api/apiUrls/message';

const addOrderMessage = (link, message, setAsUnread = false) => ({
  type: orderActionTypes.ADD_ORDER_CHAT_MESSAGE,
  payload: {
    link,
    message,
    setAsUnread,
  },
});

const addOrderSystemMessage = (link, message) => (dispatch) => {
  const msg = {
    message,
    id: helpers.getRandomId(),
    system: true,
  };

  dispatch(addOrderMessage(link, msg));
};

const setOrderStatus = (link, status, statusText) => ({
  type: orderActionTypes.SET_ORDER_STATUS,
  payload: {
    link,
    status,
    statusText,
  },
});

const setReviewStatus = (link, status) => ({
  type: orderActionTypes.SET_REVIEW_STATUS,
  payload: {
    link,
    status,
  },
});

const createOrderStart = () => ({ type: orderActionTypes.CREATE_NEW_ORDER_START });
const createOrderSuccess = (payload) => ({
  type: orderActionTypes.CREATE_NEW_ORDER_SUCCESS,
  payload,
});
const createOrderFailure = () => ({ type: orderActionTypes.CREATE_NEW_ORDER_FAIL });

const createOrder = (data, token, language) => (dispatch) => {
  dispatch(createOrderStart());
  return createOrderApi(data, token)
    .then((res) => {
      // TODO: add some redirect after successfull finishing order
      Swal.fire({
        icon: 'success',
        title: language === 'en-US' ? 'An offer for an exchange has been sent, wait for the seller to confirm the deal' : 'Отправлено предложение на обмен, дождитесь пока продавец подтвердит сделку',
      });
      dispatch(createOrderSuccess(res.data.data));
      return res.data.data;
    })
    .catch(() => {
      dispatch(createOrderFailure());
    });
};

const makeBidStart = () => ({ type: orderActionTypes.MAKE_BID_START });
const makeBidSuccess = (payload) => ({
  type: orderActionTypes.MAKE_BID_SUCCESS,
  payload,
});
const makeBidFailure = () => ({ type: orderActionTypes.MAKE_BID_FAIL });

const makeBid = (data, token, language) => (dispatch) => {
  dispatch(makeBidStart());
  return makeBidApi(data, token)
    .then((res) => {
      Swal.fire({
        icon: 'success',
        title: language === 'en-US' ? 'Bid is accepted' : 'Ставка сделана',
      });
      dispatch(makeBidSuccess(res.data.data));
      return res.data.data;
    })
    .catch(() => {
      dispatch(makeBidFailure());
    });
};

const getOrdersInfoStart = () => ({
  type: orderActionTypes.GET_ORDERS_INFO_START,
});

const getOrdersInfoSuccess = (payload) => ({
  type: orderActionTypes.GET_ORDERS_INFO_SUCCESS,
  payload,
});

const getOrdersInfoFailure = () => ({
  type: orderActionTypes.GET_ORDERS_INFO_FAIL,
});

const getOrdersInfo = (token) => (dispatch) => {
  dispatch(getOrdersInfoStart());
  getOrdersInfoApi(token)
    .then((res) => {
      dispatch(getOrdersInfoSuccess(res.data));
    })
    .catch(() => {
      dispatch(getOrdersInfoFailure());
    });
};

const getOrdersStart = () => ({
  type: orderActionTypes.GET_ORDERS_START,
});

const getOrdersSuccess = (payload) => ({
  type: orderActionTypes.GET_ORDERS_SUCCESS,
  payload,
});

const getOrdersFailure = () => ({
  type: orderActionTypes.GET_ORDERS_FAIL,
});

const getOrders = (token, type, status) => (dispatch) => {
  dispatch(getOrdersStart());
  getOrdersApi(token, type, status)
    .then((res) => {
      // eslint-disable-next-line array-callback-return
      res.data?.data.map((order) => {
        // eslint-disable-next-line no-param-reassign
        order.avatarColor = helpers.randomDarkColor();
      });
      dispatch(getOrdersSuccess(res.data));
    })
    .catch(() => {
      dispatch(getOrdersFailure());
    });
};

const getOneOrderStart = () => ({
  type: orderActionTypes.GET_ONE_ORDER_START,
});

const getOneOrderSuccess = (payload) => ({
  type: orderActionTypes.GET_ONE_ORDER_SUCCESS,
  payload,
});

const getOneOrderFailure = () => ({
  type: orderActionTypes.GET_ONE_ORDER_FAIL,
});

const getOneOrder = (token, orderLink) => (dispatch) => {
  dispatch(getOneOrderStart());
  getOneOrderApi(token, orderLink)
    .then((res) => {
      res.data.data.avatarColor = helpers.randomDarkColor();
      dispatch(getOneOrderSuccess(res.data.data));
    })
    .catch(() => {
      dispatch(getOneOrderFailure());
    });
};

const cancelOrdersStart = () => ({
  type: orderActionTypes.CANCEL_ORDER_START,
});

const cancelOrdersSuccess = () => ({
  type: orderActionTypes.CANCEL_ORDER_SUCCESS,
});

const cancelOrdersFailure = () => ({
  type: orderActionTypes.CANCEL_ORDER_FAIL,
});

const cancelOrder = (token, link) => (dispatch) => {
  dispatch(cancelOrdersStart());
  cancelOrderApi(token, link)
    .then(() => {
      batch(() => {
        dispatch(cancelOrdersSuccess());
        dispatch(addOrderSystemMessage(link, 'Вы отменили сделку'));
        dispatch(setOrderStatus(link, 50, 'Отменен'));
      });
      Swal.fire({
        icon: 'warning',
        title: 'Вы отменили сделку',
      });
    })
    .catch(() => {
      dispatch(cancelOrdersFailure());
    });
};

const confirmOrderStart = () => ({
  type: orderActionTypes.CONFIRM_ORDER_START,
});

const confirmOrderSuccess = (payload) => ({
  type: orderActionTypes.CONFIRM_ORDER_SUCCESS,
  payload,
});

const confirmOrderFailure = () => ({
  type: orderActionTypes.CONFIRM_ORDER_FAIL,
});

const confirmOrder = (token, link) => (dispatch) => {
  dispatch(confirmOrderStart());
  confirmOrderApi(token, link)
    .then(() => {
      batch(() => {
        dispatch(confirmOrderSuccess(link));
        dispatch(addOrderSystemMessage(link, 'Вы подтвердили сделку'));
        dispatch(setOrderStatus(link, 10, 'Подтвержден'));
      });
      Swal.fire({
        icon: 'success',
        title: 'Вы подтвердили сделку',
      });
    })
    .catch(() => {
      dispatch(confirmOrderFailure());
    });
};

const sendCompletedCodeStart = () => ({
  type: orderActionTypes.SEND_COMPLETED_CODE_START,
});

const sendCompletedCodeSuccess = (payload) => ({
  type: orderActionTypes.SEND_COMPLETED_CODE_SUCCESS,
  payload,
});

const sendCompletedCodeFailure = () => ({
  type: orderActionTypes.SEND_COMPLETED_CODE_FAIL,
});

const sendCompletedCode = (token, link) => (dispatch) => {
  dispatch(sendCompletedCodeStart());
  sendCompletedCodeApi(token, link)
    .then((res) => {
      dispatch(sendCompletedCodeSuccess(res.data));
    })
    .catch(() => {
      dispatch(sendCompletedCodeFailure());
    });
};

const completeOrderStart = () => ({
  type: orderActionTypes.COMPLETE_ORDER_START,
});

const completeOrderSuccess = (payload) => ({
  type: orderActionTypes.COMPLETE_ORDER_SUCCESS,
  payload,
});

const completeOrderFailure = () => ({
  type: orderActionTypes.COMPLETE_ORDER_FAIL,
});

const completeOrder = (token, link, code) => (dispatch) => {
  dispatch(completeOrderStart());
  completeOrderApi(token, link, code)
    .then((res) => {
      batch(() => {
        dispatch(completeOrderSuccess(res.data));
        dispatch(addOrderSystemMessage(link, 'Вы подтвердили получение товара, сделка завершена.'));
        dispatch(setOrderStatus(link, 30, 'Завершен'));
        document.body.style.overflow = '';
      });
      Swal.fire({
        icon: 'success',
        title: 'Вы подтвердили получение товара, сделка завершена.',
      });
    })
    .catch(() => {
      dispatch(completeOrderFailure());
    });
};

const sendReviewStart = () => ({
  type: orderActionTypes.SEND_REVIEW_START,
});

const sendReviewSuccess = (payload) => ({
  type: orderActionTypes.SEND_REVIEW_SUCCESS,
  payload,
});

const sendReviewFailure = () => ({
  type: orderActionTypes.SEND_REVIEW_FAIL,
});

const sendReview = (token, link, text, rating) => (dispatch) => {
  dispatch(sendReviewStart());
  sendReviewApi(token, link, text, rating)
    .then((res) => {
      batch(() => {
        dispatch(sendReviewSuccess(res.data));
        dispatch(setReviewStatus(link, true));
        document.body.style.overflow = '';
      });
      Swal.fire({
        icon: 'success',
        title: 'Review sent successfully',
      });
    })
    .catch(() => {
      dispatch(sendReviewFailure());
    });
};

const sendOrderMessage = (token, order, message, photos, senderRole) => (dispatch) => {
  const msg = {
    messages: message,
    photos,
    chat_id: order?.chat?.id,
  };
  return dispatch(messageActions.sendMessage(msg, token)).then(() => {
    const { username } = order.users[senderRole];
    const chatId = order.chat.id;
    const chatMsg = {
      message,
      id: helpers.getRandomId(),
      sender: order.users[senderRole],
      photos: getPhotosWithUrls(photos, username, chatId),
      created: new Date(),
    };
    dispatch(addOrderMessage(order.link, chatMsg));
  });
};

const addChatPage = (payload) => ({
  type: orderActionTypes.ADD_ORDER_CHAT_PAGE,
  payload,
});

const getChatPage = (token, orderLink, params) => (dispatch) => {
  dispatch(messageActions.getChatPage(token, params))
    .then((res) => {
      dispatch(addChatPage({
        link: orderLink,
        data: res,
      }));
    });
};

const addNewChatMessages = (orderData) => (dispatch) => {
  if (orderData?.link && orderData?.chat?.messages?.data?.[0]) {
    dispatch(addOrderMessage(orderData.link, orderData.chat.messages.data[0], true));
  }
};

const changeOrderStatus = (newStatus, orderData, userId) => ({
  type: orderActionTypes.CHANGE_ORDER_STATUS,
  payload: {
    newStatus,
    orderData,
    userId,
  },
});

const readMessageSuccess = (orderLink, messageId) => ({
  type: orderActionTypes.READ_ORDER_MESSAGE_SUCCESS,
  payload: {
    orderLink,
    messageId,
  },
});

const readMessage = (token, orderLink, chatId, messageId) => (dispatch) => (
  readMessageApi(token, chatId, messageId)
    .then((res) => {
      dispatch(readMessageSuccess(orderLink, messageId));
      return res;
    })
    .catch((err) => err)
);

const orderActions = {
  createOrder,
  makeBid,
  getOrdersInfo,
  getOrders,
  cancelOrder,
  confirmOrder,
  sendCompletedCode,
  completeOrder,
  sendReview,
  sendOrderMessage,
  getChatPage,
  addNewChatMessages,
  changeOrderStatus,
  getOneOrder,
  readMessage,
};

export default orderActions;
